import Vue from 'vue'
import Router from 'vue-router';
import store from '../store';
import {EventBus} from '../utils/event-bus'
import {getMenuByListID} from "@/services/role";

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/redirect',
      hidden: true,
      component: resolve => require(['@/pages/index'], resolve),
      children: [
        // {
        //   path: '/redirect/:path*',
        //   component: () => import('@/pages/redirect/index')
        // }
      ]
    },


    {
      path: '/',
      name: 'login',
      title: "登录页",
      component: resolve => require(['@/pages/login'], resolve)
    },
    {
      path: '/tokenLogin',
      component: resolve => require(['@/pages/tokenLogin'], resolve),
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/index',
      name: '',
      title: "侧边栏",
      component: resolve => require(['@/pages/index'], resolve),
      meta: {requireAuth: true, title: "侧边栏",},
      children: [
        {
          path: '/assets/grossList',
          name: 'GrossList',
          title: "SIM卡列表",
          component: resolve => require(['@/pages/assets/grossList/index'], resolve),
          meta: {requireAuth: true, title: "SIM卡列表",}
        },
        {
          path: '/assets/equipmentList',
          name: 'equipmentList',
          title: "自研设备出入库",
          component: resolve => require(['@/pages/assets/equipmentList/index'], resolve),
          meta: {requireAuth: true, title: "自研设备出入库",}
        },
        // {
        //   path: '/assets/storageEquipment',
        //   name: 'storageEquipment',
        //   title: "自研设备入库",
        //   component: resolve => require(['@/pages/assets/storageEquipment/index'], resolve),
        //   meta: { requireAuth: true, title: "自研设备入库", }
        // },
        {
          path: '/assets/assetsDelete',
          name: 'assetsDelete',
          title: "资产删除记录",
          component: resolve => require(['@/pages/assets/assetsDelete/index'], resolve),
          meta: {requireAuth: true, title: "资产删除记录",}
        },
        {
          path: '/assets/customerList',
          name: 'customerList',
          title: "客户管理",
          component: resolve => require(['@/pages/assets/customerList/index'], resolve),
          meta: {requireAuth: true, title: "客户管理",}
        },
        {
          path: '/assets/operator',
          name: 'operator',
          title: "运营商管理",
          component: resolve => require(['@/pages/assets/operator/index'], resolve),
          meta: {requireAuth: true, title: "运营商管理",}
        },
        {
          path: '/assets/outfieldEquipmentList',
          name: 'outfieldEquipmentList',
          title: "外采设备出库",
          component: resolve => require(['@/pages/assets/outfieldEquipmentList/index'], resolve),
          meta: {requireAuth: true, title: "外采设备出库",}
        },
        {
          path: '/assets/fundsList',
          name: 'FundsList',
          title: "SIM卡续费",
          component: resolve => require(['@/pages/assets/fundsList/index'], resolve),
          meta: {requireAuth: true, title: "SIM卡续费",}
        }, {
          path: '/assets/deviceRenewal/right',
          name: 'DeviceRenewalRight',
          title: "设备服务费明细",
          component: resolve => require(['@/pages/assets/deviceRenewal/right/index'], resolve),
          meta: {requireAuth: true, title: "设备服务费明细",}
        }, {
          path: '/assets/deviceRenewal/bill',
          name: 'DeviceRenewalBill',
          title: "服务费账单",
          component: resolve => require(['@/pages/assets/deviceRenewal/bill/index'], resolve),
          meta: {requireAuth: true, title: "服务费账单",}
        }, {
          path: '/assets/deviceRenewal/capitalFlow',
          name: 'DeviceRenewalCapitalFlow',
          title: "资金流水",
          component: resolve => require(['@/pages/assets/deviceRenewal/capitalFlow/index'], resolve),
          meta: {requireAuth: true, title: "资金流水",}
        }, {
          path: '/assets/earlyList',
          name: 'EarlyList',
          title: "超流量SIM卡",
          component: resolve => require(['@/pages/assets/earlyList/index'], resolve),
          meta: {requireAuth: true, title: "超流量SIM卡",}
        }, {
          path: '/assets/simChange',
          name: 'SimChange',
          title: "SIM卡变更记录",
          component: resolve => require(['@/pages/assets/simChange/index'], resolve),
          meta: {requireAuth: true, title: "SIM卡变更记录",}
        }, {
          path: '/assets/deliveryRecordList',
          name: 'DeliveryRecordList',
          title: "SIM卡出货记录",
          component: resolve => require(['@/pages/assets/deliveryRecordList/index'], resolve),
          meta: {requireAuth: true, title: "SIM卡出货记录",}
        },
        {
          path: '/assets/batchManagementList',
          name: 'batchManagementList',
          title: "SIM卡采购记录",
          component: resolve => require(['@/pages/assets/batchManagementList/index'], resolve),
          meta: {requireAuth: true, title: "SIM卡采购记录",}
        },
        {
          path: '/assets/returnList',
          name: 'returnList',
          title: "SIM卡退货记录",
          component: resolve => require(['@/pages/assets/returnList/index'], resolve),
          meta: {requireAuth: true, title: "SIM卡退货记录",}
        },
        {
          path: '/assets/cabinetDelivery',
          name: 'cabinetDelivery',
          title: "换电柜出入库",
          component: resolve => require(['@/pages/assets/cabinetDelivery/index'], resolve),
          meta: {requireAuth: true, title: "换电柜出入库",}
        },
        {
          path: '/assets/retirementManagement',
          name: 'retirementManagement',
          title: "SIM卡报废",
          component: resolve => require(['@/pages/assets/retirementManagement/index'], resolve),
          meta: {requireAuth: true, title: "SIM卡报废",}
        },
        {
          path: '/assets/chargingDelivery',
          name: 'chargingDelivery',
          title: "充电桩出入库",
          component: resolve => require(['@/pages/assets/chargingDelivery/index'], resolve),
          meta: {requireAuth: true, title: "充电桩出入库",}
        },
        {
          path: '/assets/warningStations',
          name: 'warningStations',
          title: "预警基站出库",
          component: resolve => require(['@/pages/assets/warningStations/index'], resolve),
          meta: {requireAuth: true, title: "预警基站出库",}
        },
        {
          path: '/assets/battery',
          name: 'battery',
          title: "自研设备列表",
          component: resolve => require(['@/pages/assets/battery/index'], resolve),
          meta: {requireAuth: true, title: "自研设备列表",}
        },
        {
          path: '/assets/changingCabinet',
          name: 'changingCabinet',
          title: "换电柜列表",
          component: resolve => require(['@/pages/assets/changingCabinet/index'], resolve),
          meta: {requireAuth: true, title: "换电柜列表",}
        },
        {
          path: '/assets/order',
          name: 'orderList',
          title: "订单管理",
          component: resolve => require(['@/pages/assets/order/index'], resolve),
          meta: {requireAuth: true, title: "订单管理",}
        },
        {
          path: '/assets/orderUpgrade',
          name: 'orderList',
          title: "订单待升级任务",
          component: resolve => require(['@/pages/assets/orderUpgrade/index'], resolve),
          meta: {requireAuth: true, title: "订单待升级任务",}
        },
        {
          path: '/assets/stockFinished',
          name: 'stockFinished',
          title: "成品库存管理",
          component: resolve => require(['@/pages/assets/stockFinished/index'], resolve),
          meta: {requireAuth: true, title: "成品库存管理",}
        },
        {
          path: '/assets/batteryWatch/index',
          name: 'BatteryWatch',
          title: "设备监控",
          component: resolve => require(['@/pages/assets/batteryWatch/index'], resolve),
          meta: {requireAuth: true, title: "设备监控",}
        }, {
          path: '/assets/getTrack',
          name: 'GetTrack',
          title: "获取轨迹",
          component: resolve => require(['@/pages/assets/getTrack/index'], resolve),
          meta: {requireAuth: true, title: "获取轨迹",}
        },
        {
          path: '/assets/systemSet/roleAdmin/index',
          name: 'roleAdmin',
          title: "角色管理",
          component: resolve => require(['@/pages/assets/systemSet/roleAdmin/index'], resolve),
          meta: {requireAuth: true, title: "角色管理",}
        },
        {
          path: '/assets/systemSet/accountAdmin/index',
          name: 'accountAdmin',
          title: "账号管理",
          component: resolve => require(['@/pages/assets/systemSet/accountAdmin/index'], resolve),
          meta: {requireAuth: true, title: "账号管理",}
        },
        {
          path: '/assets/remoteUpgrade/batterCommandBatch/index',
          name: 'batterCommandBatch',
          title: "电池命令批量执行",
          component: resolve => require(['@/pages/assets/remoteUpgrade/batterCommandBatch/index'], resolve),
          meta: {requireAuth: true, title: "电池命令批量执行",}
        },
        {
          path: '/assets/remoteUpgrade/batterCommandBatch/index',
          name: 'batterCommandBatch',
          title: "电池命令批量执行",
          component: resolve => require(['@/pages/assets/remoteUpgrade/batterCommandBatch/index'], resolve),
          meta: {requireAuth: true, title: "电池命令批量执行",}
        },
        {
          path: '/assets/remoteUpgrade/bmsUpgrade/index',
          name: 'bmsUpgrade',
          title: "BMS",
          component: resolve => require(['@/pages/assets/remoteUpgrade/bmsUpgrade/index'], resolve),
          meta: {requireAuth: true, title: "BMS",}
        },
        {
          path: '/assets/remoteUpgrade/communicationModule/index',
          name: 'communicationModule',
          title: "通讯模块",
          component: resolve => require(['@/pages/assets/remoteUpgrade/communicationModule/index'], resolve),
          meta: {requireAuth: true, title: "通讯模块",}
        },
        {
          path: "/assets/spacepage",
          name: "spacepage",
          title: "空页面",
          component: resolve => require(['@/pages/assets/spacepage/index'], resolve),
          meta: {requireAuth: true, title: "空页面",}
        },
        {
          path: '/assets/equipmentAlarmList',
          name: 'equipmentAlarmList',
          title: "设备告警",
          component: resolve => require(['@/pages/assets/equipmentAlarmList/index'], resolve),
          meta: {requireAuth: true, title: "设备告警",}
        },
        {
          path: '/assets/ProductManagement/productType',
          name: 'productType',
          title: "产品类型管理",
          component: resolve => require(['@/pages/assets/ProductManagement/productType'], resolve),
          meta: {requireAuth: true, title: "产品类型管理",}
        },
        {
          path: '/assets/ProductManagement/productModel',
          name: 'productModel',
          title: "产品型号管理",
          component: resolve => require(['@/pages/assets/ProductManagement/productModel'], resolve),
          meta: {requireAuth: true, title: "产品型号管理",}
        },
        {
          path: '/assets/ProductManagement/gradeParts',
          name: 'gradeParts',
          title: "配件等级管理",
          component: resolve => require(['@/pages/assets/ProductManagement/gradeParts'], resolve),
          meta: {requireAuth: true, title: "配件等级管理",}
        },
        {
          path: '/assets/ProductManagement/hardwareVersion',
          name: 'hardwareVersion',
          title: "硬件版本管理",
          component: resolve => require(['@/pages/assets/ProductManagement/hardwareVersion'], resolve),
          meta: {requireAuth: true, title: "硬件版本管理",}
        },
        {
          path: '/assets/ProductManagement/MCUFirmwareVersion',
          name: 'MCUFirmwareVersion',
          title: "MCU固件版本管理",
          component: resolve => require(['@/pages/assets/ProductManagement/MCUFirmwareVersion'], resolve),
          meta: {requireAuth: true, title: "MCU固件版本管理",}
        },
        {
          path: '/assets/ProductManagement/softwareVersion',
          name: 'softwareVersion',
          title: "软件版本管理",
          component: resolve => require(['@/pages/assets/ProductManagement/softwareVersion'], resolve),
          meta: {requireAuth: true, title: "软件版本管理",}
        },
        {
          path: '/assets/ProductManagement/structuralVersion',
          name: 'structuralVersion',
          title: "结构版本管理",
          component: resolve => require(['@/pages/assets/ProductManagement/structuralVersion'], resolve),
          meta: {requireAuth: true, title: "结构版本管理",}
        },
        {
          path: '/assets/ProductManagement/bmsMaterialVersion',
          name: 'bmsMaterialVersion',
          title: "BMS产品料号管理",
          component: resolve => require(['@/pages/assets/ProductManagement/bmsMaterialVersion'], resolve),
          meta: {requireAuth: true, title: "BMS产品料号管理",}
        },
        {
          path: '/assets/ProductManagement/bmsPartsVersion',
          name: 'bmsPartsVersion',
          title: "BMS配件表",
          component: resolve => require(['@/pages/assets/ProductManagement/bmsPartsVersion'], resolve),
          meta: {requireAuth: true, title: "BMS配件表",}
        },
        {
          path: '/assets/ProductManagement/productAssembly',
          name: 'productAssembly',
          title: "产品总成",
          component: resolve => require(['@/pages/assets/ProductManagement/productAssembly'], resolve),
          meta: {requireAuth: true, title: "产品总成",}
        },
        {
          path: '/assets/Technology/TechnologyManagement',
          name: 'technologyManagement',
          title: "生产技术管理",
          component: resolve => require(['@/pages/assets/Technology/TechnologyManagement'], resolve),
          meta: {requireAuth: true, title: "生产技术管理",}
        },
        {
          path: '/assets/Technology/upperComputerVersion',
          name: 'upperComputerVersion',
          title: "上位机版本",
          component: resolve => require(['@/pages/assets/Technology/upperComputerVersion'], resolve),
          meta: {requireAuth: true, title: "上位机版本",}
        },
        {
          path: '/assets/ProductManagement/params',
          name: 'productAssembly',
          title: "上位机参数",
          component: resolve => require(['@/pages/assets/ProductManagement/params'], resolve),
          meta: {requireAuth: true, title: "上位机参数",}
        },
        {
          path: '/assets/ProductManagement/deleteList',
          name: 'deleteList',
          title: "信息删除记录",
          component: resolve => require(['@/pages/assets/ProductManagement/deleteList'], resolve),
          meta: {requireAuth: true, title: "信息删除记录",}
        },
        {
          path: '/assets/remoteUpgrade/upgradingStrategy/index',
          name: 'upgradingStrategy',
          title: "升级策略",
          component: resolve => require(['@/pages/assets/remoteUpgrade/upgradingStrategy/index'], resolve),
          meta: {requireAuth: true, title: "升级策略",}
        },
        {
          path: '/assets/remoteUpgrade/upgradeTask/index',
          name: 'upgradeTask',
          title: "升级任务",
          component: resolve => require(['@/pages/assets/remoteUpgrade/upgradeTask/index'], resolve),
          meta: {requireAuth: true, title: "升级任务",}
        },
        {
          path: '/assets/remoteUpgrade/newUpgradeTask/index',
          name: 'upgradeTask',
          title: "推送升级任务",
          component: resolve => require(['@/pages/assets/remoteUpgrade/newUpgradeTask/index'], resolve),
          meta: {requireAuth: true, title: "推送升级任务",}
        },
        {
          path: '/assets/equipmentOrderChange',
          name: 'equipmentOrderChange',
          title: "设备订单变更",
          component: resolve => require(['@/pages/assets/equipmentOrderChange/index'], resolve),
          meta: {requireAuth: true, title: "设备订单变更",}
        },
        {
          path: "/assets/afterSales",
          name: "afterSales",
          title: "售后工单",
          component: resolve => require(['@/pages/assets/afterSales/index'], resolve),
          meta: {requireAuth: true, title: "售后工单",}
        },
        {
          path: "/assets/afterSales/detail",
          name: "afterSalesDetail",
          title: "售后详情",
          component: resolve => require(['@/pages/assets/afterSales/detail'], resolve),
          meta: {requireAuth: true, title: "售后详情",}
        },
        {
          path: "/assets/afterSales/edit",
          name: "afterSalesEdit",
          title: "编辑工单",
          component: resolve => require(['@/pages/assets/afterSales/edit'], resolve),
          meta: {requireAuth: true, title: "编辑工单",}
        },
        {
          path: "/assets/cabinetAfterSales",
          name: "cabinetAfterSales",
          title: "换电柜售后工单",
          component: resolve => require(['@/pages/assets/cabinetAfterSales/index'], resolve),
          meta: {requireAuth: true, title: "换电柜售后工单",}
        },
        {
          path: "/assets/cabinetAfterSales/detail",
          name: "cabinetAfterSalesDetail",
          title: "换电柜售后工单详情",
          component: resolve => require(['@/pages/assets/cabinetAfterSales/detail'], resolve),
          meta: {requireAuth: true, title: "换电柜售后工单详情",}
        },
        {
          path: '/assets/productionTaskManagement',
          name: 'productionTaskManagement',
          title: "生产任务管理",
          component: resolve => require(['@/pages/assets/productionTaskManagement'], resolve),
          meta: {requireAuth: true, title: "生产任务管理",}
        },
        {
          // 设备平台这里仅展示换电柜检测汇总结果，不承担检测执行入口。
          path: '/assets/productionCabinetCheck',
          name: 'productionCabinetCheck',
          title: "换电柜检测数据",
          component: resolve => require(['@/pages/assets/productionCabinetCheck/index'], resolve),
          meta: {requireAuth: true, title: "换电柜检测数据",}
        },
        // {
        //   path: '/assets/productionTaskManagement',
        //   name: 'productionTaskManagement',
        //   title: "生产任务管理",
        //   component: resolve => require(['@/pages/assets/productionTaskManagement'], resolve),
        //   meta: {requireAuth: true, title: "生产任务管理",}
        // },

        {
          path: '/assets/equipmentDesign',
          name: 'equipmentDesign',
          title: "设备检测数据",
          component: resolve => require(['@/pages/assets/equipmentDesign'], resolve),
          meta: {requireAuth: true, title: "设备检测数据",}
        },
        {
          path: "/assets/saleclassification",
          name: "saleclassification",
          title: "售后分类",
          component: resolve => require(['@/pages/assets/saleclassification/index'], resolve),
          meta: {requireAuth: true, title: "售后分类",}
        },
        {
          path: "/assets/questionBank",
          name: "questionBank",
          title: "公共题库",
          component: resolve => require(['@/pages/assets/questionBank/index'], resolve),
          meta: {requireAuth: true, title: "公共题库",}
        },
        {
          path: "/assets/questionBank/missingQuestions",
          name: "questionBankMissingQuestions",
          title: "未收录问题",
          component: resolve => require(['@/pages/assets/questionBank/missingQuestions'], resolve),
          meta: {requireAuth: true, title: "未收录问题",}
        },
        {
          path: "/assets/questionBank/diagnosisDefinitions",
          name: "questionBankDiagnosisDefinitions",
          title: "诊断码定义",
          component: resolve => require(['@/pages/assets/questionBank/diagnosisDefinitions'], resolve),
          meta: {requireAuth: true, title: "诊断码定义",}
        },
        {
          path: '/assets/cabinetWatch/index',
          name: 'cabinetWatch',
          title: "换电柜监控",
          component: resolve => require(['@/pages/assets/cabinetWatch/index'], resolve),
          meta: {requireAuth: true, title: "换电柜监控",}
        },
        {
          path: '/assets/batteryIOTBMS',
          name: 'batteryIOTBMS',
          title: "IOT-BMS列表",
          component: resolve => require(['@/pages/assets/batteryIOTBMS/index'], resolve),
          meta: {requireAuth: true, title: "IOT-BMS列表",}
        },
        {
          path: '/assets/battery/BLBMS',
          name: 'batteryBLBMS',
          title: "BL-BMS列表",
          component: resolve => require(['@/pages/assets/batteryBLBMS/index'], resolve),
          meta: {requireAuth: true, title: "BL-BMS列表",}
        },
        {
          path: '/assets/battery/BLBMS/watch',
          name: 'BatteryBLEWatch',
          title: "BL设备监控",
          component: resolve => require(['@/pages/assets/batteryBLBMS/watch/index'], resolve),
          meta: {requireAuth: true, title: "BL设备监控",}
        },
        {
          path: '/assets/cabinetAlarmList',
          name: 'cabinetAlarmList',
          title: "换电柜告警",
          component: resolve => require(['@/pages/assets/cabinetAlarmList/index'], resolve),
          meta: {requireAuth: true, title: "换电柜告警",}
        },
        {
          path: '/assets/centerControl',
          name: 'centerControl',
          title: "IOT-中控列表",
          component: resolve => require(['@/pages/assets/centerControl/index'], resolve),
          meta: {requireAuth: true, title: "IOT-中控列表",}
        },
        {
          path: '/assets/centerControlAlarmList',
          name: 'centerControlAlarmList',
          title: "中控告警",
          component: resolve => require(['@/pages/assets/centerControlAlarmList/index'], resolve),
          meta: {requireAuth: true, title: "中控告警",}
        },
        {
          path: '/assets/deviceOfflineRecord',
          name: 'deviceOfflineRecord',
          title: "设备离线记录",
          component: resolve => require(['@/pages/assets/deviceOfflineRecord/index'], resolve),
          meta: {requireAuth: true, title: "设备离线记录",}
        },
        {
          path: '/assets/centerControlWatch/index',
          name: 'centerControlWatch',
          title: "中控监控",
          component: resolve => require(['@/pages/assets/centerControlWatch/index'], resolve),
          meta: {requireAuth: true, title: "中控监控",}
        },
        {
          path: '/assets/supplierList',
          name: 'supplierList',
          title: "SIM卡供应商列表",
          component: resolve => require(['@/pages/assets/supplierList/index'], resolve),
          meta: {requireAuth: true, title: "SIM卡供应商列表",}
        },


      ]
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  if (to.meta.requireAuth) {
    if (sessionStorage.getItem("token")) {
      const hasPermission = store.getters.permission && store.getters.permission.length > 0;
      if (hasPermission) {
        next()
      } else {
        const ids = await getMenuByListID(sessionStorage.getItem("roleIds"));
        if (ids.data.length == 0) {
          next({path: '/'})
          return;
        }
        store.dispatch('permission/setPermission', ids.data)
      }
      next();

    } else {
      next({
        path: '/',
        // query: { redirect: to.fullPath }
      })

    }
  } else {
    if (to.path !== "/") {
      next({path: '/',});
    } else {
      next();
    }
  }
})
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {

  return originalPush.call(this, location).catch(err => err)

}
export default router



// WEBPACK FOOTER //
// ./src/router/index.js